import { useContext } from 'react';
import { ThgConfigModel } from '../Config/ThgConfigModel';
import { extendedConfigContext } from '../Config/extendedConfigContext';

function useThgConfig(): ThgConfigModel {
  return useContext<ThgConfigModel>(extendedConfigContext);
}

export default useThgConfig;
